import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from 'dayjs';
import m3u8Video from '@/components/m3u8Video';
export default {
  components: {
    m3u8Video: m3u8Video
  },
  data: function data() {
    return {
      dayjs: dayjs,
      id: '20260817',
      list: [{
        name: '增氧机',
        group: 'group_a',
        items: [],
        open: '2087859321893695488',
        close: '2087859406161457152'
      }, {
        name: '增氧机',
        group: 'group_b',
        items: [],
        open: '2087859495856648192',
        close: '2087859550747504640'
      }, {
        name: '增氧机',
        group: 'group_c',
        items: [],
        open: '2087859614232489984',
        close: '2087859673233764352'
      }, {
        name: '增氧机',
        group: 'group_d',
        items: [],
        open: '2087859797171253248',
        close: '2087860078671966208'
      }, {
        name: '增氧机',
        group: 'group_e',
        items: [],
        open: '2087860574967181312',
        close: '2087860645897056256'
      }, {
        name: '增氧机',
        group: 'group_f',
        items: [],
        open: '2087860762238660608',
        close: '2087860818308116480'
      }, {
        name: '增氧机',
        group: 'group_g',
        items: [],
        open: '2087860891440001024',
        close: '2087860957437374464'
      }, {
        name: '增氧机',
        group: 'group_h',
        items: [],
        open: '2087861045534535680',
        close: '2087861113582923776'
      }],
      lastData: {},
      detail: {},
      waveValues: [] // 改为数组，便于Vue2响应式
      ,
      waveTimer: null // 改为单个计时器，提高性能
      ,
      startTimes: [] // 改为数组
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.getAeration();
            _context.next = 3;
            return _this.getLast();
          case 3:
            _context.next = 5;
            return _this.getList();
          case 5:
            _this.timer = setInterval(function () {
              _this.getLast();
            }, 2000);

            // 初始化波动数据
            _this.initWaveData();

            // 启动波动计时器
            _this.startWaveTimer();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.waveTimer) {
      clearInterval(this.waveTimer);
      this.waveTimer = null;
    }
  },
  methods: {
    backClick: function backClick() {
      this.$router.back();
    },
    getAeration: function getAeration() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$api['smartControlDetail'](_this2.id);
            case 2:
              res = _context2.sent;
              _this2.detail = res.data || {};
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getList: function getList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, items, item, index, _iterator, _step, opt;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$api['smartControlItemQuery']({
                page: 1,
                limit: -1,
                smartControlId: _this3.id,
                sortField: '^sort'
              });
            case 2:
              res = _context3.sent;
              for (index in _this3.list) {
                _this3.$set(_this3.list[index], 'items', []);
                items = [];
                _iterator = _createForOfIteratorHelper(res.data);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    opt = _step.value;
                    if (_this3.list[index].group === opt.typeGroup) {
                      items.push(_objectSpread(_objectSpread({}, opt), {}, {
                        value: _this3.lastData[opt.typeCode]
                      }));
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                _this3.$set(_this3.list[index], 'items', items);
              }
              console.log('list', _this3.list);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getLast: function getLast() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.$api['smartControlLastRecord'](_this4.id);
            case 2:
              res = _context4.sent;
              _this4.lastData = res.data || {};
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    cmdClick: function cmdClick(_ref, state) {
      var _this5 = this;
      var open = _ref.open,
        close = _ref.close;
      this.$confirm('确定要执行吗').then(function () {
        _this5.$api['smartControlCmdExecute'](state === '停止' ? open : close).then(function (res) {
          if (res.data) {
            _this5.$message.success('执行成功');
            _this5.getLast();
          } else {
            _this5.$message.error('执行失败');
          }
        });
      });
    } // 判断增氧机是否在运行
    ,
    isAerationRunning: function isAerationRunning(index) {
      var item = this.list[index];
      if (!item || !item.items || item.items.length === 0) return false;
      try {
        var firstItem = item.items[0];
        if (!firstItem || !firstItem.valueEnums) return false;
        var enums = JSON.parse(firstItem.valueEnums);
        var state = enums[firstItem.value];
        return state === '启动';
      } catch (e) {
        return false;
      }
    } // 初始化波动数据
    ,
    initWaveData: function initWaveData() {
      var _this6 = this;
      // 使用$set确保响应式
      this.waveValues = [];
      this.startTimes = [];
      this.list.forEach(function (_, index) {
        _this6.$set(_this6.waveValues, index, 0);
        _this6.$set(_this6.startTimes, index, Date.now() + index * 500); // 每个项错开起始时间
      });
    } // 启动波动计时器（使用单个计时器提高性能）
    ,
    startWaveTimer: function startWaveTimer() {
      var _this7 = this;
      if (this.waveTimer) {
        clearInterval(this.waveTimer);
        this.waveTimer = null;
      }
      this.waveTimer = setInterval(function () {
        var now = Date.now();
        var hasChange = false;
        _this7.list.forEach(function (item, index) {
          // 只有增氧机运行时才更新波动值
          if (!_this7.isAerationRunning(index)) {
            return;
          }
          var startTime = _this7.startTimes[index];
          if (!startTime) return;
          var elapsed = (now - startTime) / 1000;

          // 从0开始递增，然后稳定在9.4-9.8之间
          var value;
          if (elapsed < 5) {
            // 前5秒从0递增到9.6
            value = elapsed / 5 * 9.6;
          } else {
            // 之后在9.4-9.8之间波动
            var baseValue = 9.6;
            var amplitude = 0.2;
            // 使用不同相位使每个项波动不同步
            var phase = index * 0.5;
            value = baseValue + amplitude * Math.sin((elapsed - 5) * Math.PI * 0.8 + phase);
          }

          // 限制范围并保留2位小数
          var newValue = Math.round(Math.max(0, Math.min(9.8, value)) * 100) / 100;

          // 只有值发生变化时才更新
          if (_this7.waveValues[index] !== newValue) {
            _this7.$set(_this7.waveValues, index, newValue);
            hasChange = true;
          }
        });

        // 如果没有任何变化，强制更新一次（可选）
        // if (!hasChange) {
        //   this.$forceUpdate()
        // }
      }, 1000);
    } // 获取某个项的当前值
    ,
    getWaveValue: function getWaveValue(index) {
      // 确保返回值有效
      var value = this.waveValues[index];
      return value !== undefined && value !== null ? value : 0;
    } // 重置所有项的波动
    ,
    resetAllWaves: function resetAllWaves() {
      var _this8 = this;
      var now = Date.now();
      this.list.forEach(function (_, index) {
        _this8.$set(_this8.startTimes, index, now + index * 500);
        _this8.$set(_this8.waveValues, index, 0);
      });
    }
  }
};